"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var button_component_1 = require("../../../common/buttons/button_component");
var route_path_1 = require("../../../constants/route_path");
var array_helpers_1 = require("../../../utils/array_helpers");
var menu_constants_1 = require("../../../menuList/menu_constants");
var pop_up_1 = require("../../../common/modal/pop-up");
var multi_selector_1 = require("../../../common/checkbox/multi_selector");
var react_redux_1 = require("react-redux");
var user_logistics_api_1 = require("./user_logistics_api");
var Create_User_Logistics_1 = require("./Create_User_Logistics");
var ManageAccessButton = function (_a) {
    var data = _a.data;
    var _b = React.useState(false), selectCompanies = _b[0], setSelectCompanies = _b[1];
    var _c = React.useState(), selectedCompanies = _c[0], setSelectedCompanies = _c[1];
    var _d = React.useState({}), editCompanies = _d[0], setEditCompanies = _d[1];
    var _e = React.useState({}), editResponse = _e[0], setEditResponse = _e[1];
    var _f = React.useState(false), isError = _f[0], setIsError = _f[1];
    var _g = React.useState(false), openEditPop = _g[0], setOpenEditPop = _g[1];
    var _h = React.useState(null), editUserDetails = _h[0], setEditUserDetails = _h[1];
    var dataIdRef = React.useRef(data.id);
    dataIdRef.current = data.id;
    var nav = (0, react_router_dom_1.useNavigate)();
    var companiesList = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList.company_names; });
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.Admin_User_Management);
    var EditUserHandler = function () {
        fetchEditDetails();
    };
    var EditIconHandler = function () {
        var rowId = data.id;
        setOpenEditPop(true);
        (0, user_logistics_api_1.getUserLogisticsDetails)(rowId)
            .then(function (res) {
            if (dataIdRef.current !== rowId) {
                return;
            }
            setEditUserDetails(res);
        })
            .catch(function (err) {
            console.log('user-logistics/details error::', err);
        });
    };
    var multiSelecthandler = function (value) {
        setSelectedCompanies(value);
    };
    var fetchEditDetails = function () {
        (0, user_logistics_api_1.editDetails)(data.id)
            .then(function (res) {
            var response = res.data;
            var companies = [];
            var selectedCompanies = [];
            if (response.length < 1) {
                var responseData_1 = [];
                companiesList.forEach(function (companyData) {
                    var responseObj = {
                        company_id: companyData.value,
                        company_name: companyData.label,
                        states: [],
                        all_state_access: true
                    };
                    responseData_1.push(responseObj);
                });
                response['access_details'] = responseData_1;
            }
            response.access_details.forEach(function (regionDetails) {
                var obj = {
                    id: regionDetails.company_id,
                    label: regionDetails.company_name,
                    value: regionDetails.company_id
                };
                companies.push(obj);
                companiesList === null || companiesList === void 0 ? void 0 : companiesList.filter(function (companyDetails) {
                    if (companyDetails.label === regionDetails.company_name) {
                        selectedCompanies.push(companyDetails);
                    }
                });
            });
            setEditResponse(response);
            setEditCompanies(selectedCompanies);
            setSelectCompanies(true);
            setSelectedCompanies(selectedCompanies);
        })
            .catch(function (err) {
        });
    };
    var submitCompanySelection = function () {
        var values = [];
        if (selectedCompanies.length > 0) {
            setIsError(false);
            if (editCompanies.length != selectedCompanies.length) {
                selectedCompanies.forEach(function (companyDetails) {
                    values.push(companyDetails.label);
                });
                var payload = {
                    user_id: data.id,
                    all_company_access: selectedCompanies.length === companiesList.length,
                    companies: values
                };
                (0, user_logistics_api_1.submitCompanies)(payload);
            }
            var editDetails_1 = {
                data: editResponse,
                selectedCompanies: selectedCompanies,
                all_company_access: selectedCompanies.length === companiesList.length
            };
            nav("/".concat(route_path_1.default.PATHS.User_Logistics, "/").concat(route_path_1.default.PATHS.Edit_Region, "/").concat(data.id), { state: editDetails_1 });
            setSelectCompanies(false);
        }
        else {
            setIsError(true);
        }
    };
    return (React.createElement("div", { className: "regionicons" },
        React.createElement("div", null,
            React.createElement(button_component_1.default, { buttonName: 'Manage Access', color: "yellow-outline", onClickHandler: EditUserHandler, isError: !features[menu_constants_1.FEATURE_CONSTANTS.adminUserEdit] })),
        React.createElement("div", null,
            React.createElement(material_1.IconButton, { className: "icon-btn", onClick: EditIconHandler, disabled: !features[menu_constants_1.FEATURE_CONSTANTS.adminUserEdit] },
                React.createElement("span", { className: "icon-edit" }))),
        React.createElement(Create_User_Logistics_1.default, { openPopToAdd: openEditPop, setPopToAdd: setOpenEditPop, setPageload: function () { }, isEdit: true, editUserDetails: editUserDetails }),
        React.createElement(pop_up_1.default, { open: selectCompanies, popUpSize: "popup-lg" },
            React.createElement("div", { className: "modal-header header-wrapper" },
                React.createElement("p", { className: "sub-heading" }, "Please select companies")),
            React.createElement(multi_selector_1.default, { label: "Select Company", size: "dropdown-lg", dropDownList: (companiesList === null || companiesList === void 0 ? void 0 : companiesList.length) > 0 ? companiesList : [], onChangeHnadlre: function (event) { return multiSelecthandler(event); }, value: selectedCompanies }),
            isError ? (React.createElement("div", { className: "error" }, "Please select atleast one company")) : null,
            React.createElement("div", { className: "modal-footer" },
                React.createElement(button_component_1.default, { onClickHandler: function () {
                        setSelectCompanies(false);
                    }, buttonName: "Cancel", color: "yellow-outline" }),
                React.createElement(button_component_1.default, { buttonName: "Assign", color: "yellow", onClickHandler: submitCompanySelection })))));
};
exports.default = ManageAccessButton;
